export default {"src":"/_next/static/media/amazon.ad91c678.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};